module.exports = __webpack_public_path__ + "static/media/image.b27afa98.png";